import slick from "slick-carousel";
(() => {
  const sliderWrapper = $(".webinar__slider");
  const blogWebinar = $(".webinar__three-slide");
  const videoWebinar = $(".webinar_four-slide");
  const url = webinar.api_url;
  const options = {
    method: "GET",
    headers: {
      "X-API-KEY": "jXP+9HWYmrkeWXDLvuv6R0PZAhn5yyS9"
    }
  };

  function displayPosts(data) {
    if (data["offers"] && data["offers"].length) {
      const blocksHTML = data["offers"].map(
        item => `
          <div class="webinar__slide">
            <a href="https://academy.tytan.com/pl/trainings/${item.id}" target="_blank">
              <div class="webinar__tag">
                ${webinar.watch_text}
              </div>
              <div class="webinar__img-wrapper">
                <img src="${item.image.href}">
              </div>
              <div class="webinar__block-text-wrapper">
                <div class="webinar__block-text-top">
                    <div href="https://academy.tytan.com/pl/trainings/${item.id}" class="webinar__academy-link">
                      Webinar
                    </div>
                  <div class="webinar__category">
                    ${item.category.name}
                  </div>
                </div>
                <div class="webinar__block-text">
                  ${item.offerTitle}
                </div>
              </div>
            </a>
          </div>
        `
      );

      return blocksHTML;
    }
  }

  if (sliderWrapper.length) {
    fetch(url, options)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response error");
        }

        return response.json();
      })
      .then(data => {
        sliderWrapper.html(displayPosts(data));
        sliderWrapper.slick({
          speed: 600,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
          prevArrow:
            '<span class="webinar__arrow webinar__arrow--prev"></span>',
          nextArrow:
            '<span class="webinar__arrow  webinar__arrow--next"></span>',
          responsive: [
            {
              breakpoint: 1250,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      })
      .catch(error => console.error("There has been a problem: ", error));
  } else if (blogWebinar.length) {
    fetch(url, options)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response error");
        }

        return response.json();
      })
      .then(data => {
        blogWebinar.html(displayPosts(data));
        blogWebinar.slick({
          speed: 600,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          prevArrow:
            '<span class="webinar__arrow webinar__arrow--prev"></span>',
          nextArrow:
            '<span class="webinar__arrow  webinar__arrow--next"></span>',
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1.2
              }
            }
          ]
        });
      })
      .catch(error => console.error("There has been a problem: ", error));
  } else if (videoWebinar.length) {
    fetch(url, options)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response error");
        }

        return response.json();
      })
      .then(data => {
        videoWebinar.html(displayPosts(data));
        videoWebinar.slick({
          speed: 600,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          prevArrow:
            '<span class="webinar__arrow webinar__arrow--prev"></span>',
          nextArrow:
            '<span class="webinar__arrow  webinar__arrow--next"></span>',
          responsive: [
            {
              breakpoint: 1050,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1.2
              }
            }
          ]
        });
      })
      .catch(error => console.error("There has been a problem: ", error));
  }
})();
